<template>
  <div>
    <div class="floating-wrapper">
      <div
        class="input-main"
        @click="showItemsCount = false"
        @mouseenter="getClientsPhoneCallsLogCountCountStats()"
      >
        <span class="calls-stats">{{ kFormatter(callsCount) }}</span>
      </div>
      <!--openMenu = !openMenu;-->

      <!--      <span-->
      <!--        @click="showItemsCount = false"-->
      <!--        v-if="showItemsCount"-->
      <!--        class="selsected-count"-->
      <!--      >-->
      <!--        {{ selectedItems.length }} +-->
      <!--      </span>-->
    </div>
    <!--    <div class="root" v-if="showResults || openMenu">-->
    <!--      <input-->
    <!--        type="checkbox"-->
    <!--        class="all-checkbox"-->
    <!--        @click="checkSelectAll"-->
    <!--        :checked="selectAll"-->
    <!--        id="check-all"-->
    <!--      />-->
    <!--      <label class="label-check-all" for="check-all">All </label>-->
    <!--      <input type="checkbox" class="item-checkbox" id="exclude" />-->
    <!--      <label class="item-text" for="exclude">Exclusion</label>-->
    <!--      <div class="dropdown-divider"></div>-->
    <!--      <div v-if="showResults">-->
    <!--        <ul>-->
    <!--          <li v-for="(opt, idx) in result" :key="idx">-->
    <!--            <input-->
    <!--              type="checkbox"-->
    <!--              class="item-checkbox"-->
    <!--              v-model="selectedItems"-->
    <!--              :value="opt"-->
    <!--              :id="opt.id"-->
    <!--            />-->
    <!--            <label class="item-text" :title="opt.name" :for="opt.id">-->
    <!--              {{ opt.name | truncate(11) }}</label-->
    <!--            >-->
    <!--            <span class="item-counter"> {{ getStats(opt.type).count }}</span>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </div>-->
    <!--      <div v-if="openMenu && !showResults">-->
    <!--        <ul>-->
    <!--          <li v-for="(opt, idx) in filterOptions()" :key="idx">-->
    <!--            <input-->
    <!--              type="checkbox"-->
    <!--              class="item-checkbox"-->
    <!--              v-model="selectedItems"-->
    <!--              :value="opt"-->
    <!--              :id="opt.id"-->
    <!--            />-->
    <!--            <label class="item-text" :title="opt.name" :for="opt.id">-->
    <!--              {{ opt.name | truncate(11) }}-->
    <!--              <span class="item-counter"> {{ getStats(opt.type).count }}</span>-->
    <!--            </label>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </div>-->

    <!--      <div class="tag-form-btns">-->
    <!--        <a-->
    <!--          class="tag-form-cancel-btn"-->
    <!--          href="javascript:void(0)"-->
    <!--          @click.prevent="closeSelect"-->
    <!--          ><span class="fas fa-times"></span-->
    <!--        ></a>-->

    <!--        <a-->
    <!--          class="tag-form-ok-btn"-->
    <!--          href="javascript:void(0)"-->
    <!--          @click.prevent="resetSelect"-->
    <!--          ><span class="fas fa-sync"></span-->
    <!--        ></a>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import apiClientCreator from "../../../../../../helpers/api/request";

export default {
  name: "MultiSelect.component",
  props: {
    options: {
      type: Array,
      required: true
    },
    resetList: {
      type: Boolean,
      required: false
    },
    statsData: {
      type: Array,
      required: false,
      default: () => []
    },
    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    queryObject: {
      type: Object
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      selectedItems: [],
      infoData: [],
      openMenu: false,
      showResults: false,
      searchTagQuery: "",
      result: [],
      showItemsCount: false,
      selectAll: false,
      callsCount: null,
      allowedFilters: []
    };
  },

  watch: {
    initiatedFiltering() {
      this.getClientsPhoneCallsLogCountCountStats();
    },
    searchTagQuery: function() {
      this.selectedItems.length > 0 && this.searchTagQuery.length === 0
        ? (this.showItemsCount = true)
        : (this.showItemsCount = false);
      this.result = this.filterList(this.searchTagQuery);
      if (this.result.length > 0) {
        this.showResults = true;
      }
      if (this.searchTagQuery === "") {
        this.showResults = false;
      }
    },
    resetList: function() {
      if (this.resetList === true) {
        this.selectedItems = [];
      }
    },
    selectedItems: function() {
      if (this.selectedItems.length > 0 && this.searchTagQuery.length === 0) {
        this.showItemsCount = true;
      } else {
        this.showItemsCount = false;
      }
      //   this.openMenu = false;
      //   this.$emit("input", this.selectedItems);
      //    this.$emit("close");
    }
  },

  methods: {
    getClientsPhoneCallsLogCountCountStats() {
      if (
        this.queryObject.hasOwnProperty("deposit_at_from") ||
        this.queryObject.hasOwnProperty("registered_on_from") ||
        this.queryObject.hasOwnProperty("last_modified_from") ||
        this.queryObject.hasOwnProperty("last_referral_from") ||
        this.queryObject.hasOwnProperty("last_transfer_from") ||
        this.queryObject.hasOwnProperty("last_modified_personal_from") ||
        this.queryObject.hasOwnProperty("scheduled_call_from") ||
        this.queryObject.hasOwnProperty("assigned_at_from")
      )
        // const queryParams = this.getQueryParams();
        apiClientCreator(`client/stats/clients/calls/log`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.callsCount = res.data;
          });
      /*        .catch(err => {
                          this.requestNaUsersBusy = false;
                        });*/
    },
    filterOptions() {
      if (this.statsData.length > 0) {
        return this.options.filter(
          item => this.getStats(item.type).count !== 0
        );
      }
      return [];
    },
    getStats(i) {
      return this.statsData.find(item => item.device_type === i);
    },
    outClose() {
      // this.openMenu = false
      //      this.$emit("input", this.selectedItems);

      if (this.openMenu === true) {
        this.$emit("input", this.selectedItems);

        this.closeSelect();
      }
    },
    checkSelectAll: function() {
      this.selectedItems = [];
      let device;
      if (!this.selectAll) {
        for (device in this.filterOptions()) {
          this.selectedItems.push(this.this.filterOptions()[device]);
        }
      }
      this.selectAll = !this.selectAll;
    },
    closeSelect() {
      this.searchTagQuery = "";
      this.showResults = false;
      this.openMenu = false;
    },
    resetSelect() {
      //  alert()
      this.selectAll = false;
      this.selectedItems = [];
      this.$emit("input", this.selectedItems);
      this.$emit("reset");
      this.closeSelect();
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
      return "";
    },
    filterList(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              // The last word - ok with the word being "startswith"-like
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              // Not the last word - expect the whole word exactly
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.options.filter(item => {
        return searchRegex.test(item.name);
      });
    }
  }
};
</script>

<style scoped>
.floating-wrapper {
  position: relative;
}

.selsected-count {
  position: absolute;
  top: 8px;
  left: 10px;
  background: white;
  font-size: 8pt;
  height: 20px;
  width: 80%;
}

.root {
  position: absolute;
  top: 30px;
  left: 0px;
  width: max-content;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 5px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
}

ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
}

li:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.item-text {
  vertical-align: middle;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 9pt;
  cursor: pointer;
}

.item-checkbox {
  vertical-align: middle;
  margin-bottom: 4px;
  margin-right: 5px;
}

.item-counter {
  font-size: 8pt;
  font-weight: bolder !important;
  margin-left: 10px;
  /*float: right;
        margin-top: 5px;*/
}

.label-check-all {
  font-family: "Montserrat", Montserrat, serif;
  font-size: 9pt;
  cursor: pointer;
  margin-right: 20px;
}

.all-checkbox {
  vertical-align: middle;
  margin-bottom: 5px;
  margin-right: 5px;
  text-align: left;
}

.tag-form-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 5px;
}

.tag-form-ok-btn {
  color: green !important;
  float: left;
  margin-left: 5px;
  margin-top: 5px;
}

.input-main {
  width: 35px;
  margin-left: 4px;
  position: relative;
  padding-top: 15%;
  /* border-radius: 4px; */
  border: 0;
  /*background: #f5f7ff;*/
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 11px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  font-weight: normal;
  text-transform: uppercase;
  border-radius: 5px;
  font-weight: 600;
  border: 1px solid #d7d7d7;
  /*width: 35px;*/
  /*margin-left: 4px;*/
  /*position: relative;*/
  /*!*padding-top: 5px;*!*/
  /*!*border-radius: 4px;*!*/
  /*border: 0;*/
  /*background: #f5f7ff;*/
  /*height: 30px;*/
  /*overflow: hidden;*/
  /*max-width: 100%;*/
  /*text-overflow: ellipsis;*/
  /*font-size: 9px;*/
  /*-webkit-appearance: none;*/
  /*-moz-appearance: none;*/
  /*-o-appearance: none;*/
  /*box-sizing: border-box;*/
  /*cursor: pointer;*/
  /*transition-duration: 0.4s;*/
  /*font-weight: normal;*/
  /*text-transform: uppercase;*/
  /*border-radius: 5px;*/
  /*font-weight: 600;*/
  /*border: 1px solid #546e7a;*/
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}

/*
input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  !*  padding: 3px 0px 3px 3px;
        margin: 5px 1px 3px 0px;*!
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  !* padding: 3px 0px 3px 3px;*!
  border: 1px solid rgba(81, 203, 238, 1);
}
*/

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.calls-stats {
  /*margin-left: 5px;*/
}
</style>
